import { useMemo, useState } from "react";
import { Card, SectionHeader, TextInput } from "../../components/lib";
import { TabBar, ListRow } from "../../components/lib.overlay";
import { TASKS, Task } from "../../mocks/workspaceData";

const STATUS_META: Record<Task["status"], { bg: string; fg: string }> = {
  todo:          { bg: "var(--ph-neutral-tint)", fg: "var(--ph-ink-muted)"},
  "in-progress": { bg: "var(--ph-ai-tint)",       fg: "var(--ph-ai)"       },
  review:        { bg: "var(--ph-warning-tint)", fg: "var(--ph-warning)"  },
  done:          { bg: "var(--ph-success-tint)", fg: "var(--ph-success)"  },
};

export default function Tasks() {
  const [tab, setTab] = useState<Task["status"] | "all">("all");
  const [q, setQ] = useState("");
  const filtered = useMemo(() => TASKS.filter((t) =>
    (tab === "all" || t.status === tab) &&
    (!q || t.title.toLowerCase().includes(q.toLowerCase()) || t.owner.toLowerCase().includes(q.toLowerCase())),
  ), [tab, q]);

  return (
    <div className="space-y-6" data-testid="ws-tasks">
      <Card testId="ws-t-filters">
        <TextInput value={q} onChange={setQ} placeholder="Search tasks…" testId="ws-t-search" />
        <div className="mt-4">
          <TabBar<Task["status"] | "all">
            testId="ws-t-tabs"
            active={tab}
            onChange={setTab}
            tabs={[
              { key: "all",          label: "All" },
              { key: "todo",         label: "Todo" },
              { key: "in-progress",  label: "In progress" },
              { key: "review",       label: "Review" },
              { key: "done",         label: "Done" },
            ]}
          />
        </div>
      </Card>

      <Card padded={false} testId="ws-t-list-card">
        <div className="p-5" style={{ borderBottom: "1px solid var(--ph-border-subtle)" }}>
          <SectionHeader eyebrow="Tasks" title={`${filtered.length} task${filtered.length === 1 ? "" : "s"}`} />
        </div>
        <div className="p-2">
          {filtered.map((t) => {
            const m = STATUS_META[t.status];
            return (
              <ListRow key={t.id} testId={`ws-tk-${t.id}`}
                label={<span className="inline-flex items-center gap-2">{t.title}
                  <span className="px-1.5 py-0.5 text-[9px] font-semibold uppercase" style={{ letterSpacing: "0.14em", background: m.bg, color: m.fg, borderRadius: "var(--ph-radius-sm)" }}>{t.status}</span>
                </span>}
                sublabel={<>{t.module} · {t.owner} · {t.dueRelative} · from {t.assignedBy}</>}
                trailing={<span className="text-[10px] uppercase tracking-[0.14em]" style={{ color: t.priority === "high" ? "var(--ph-danger)" : t.priority === "medium" ? "var(--ph-warning)" : "var(--ph-ink-muted)" }}>{t.priority}</span>}
              />
            );
          })}
        </div>
      </Card>
    </div>
  );
}
